import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import { combineReducers } from '@reduxjs/toolkit';

import categoriesReducer from './slices/categoriesSlice';
import subcategoriesReducer from './slices/subcategoriesSlice';
import contactInfoReducer from './slices/contactInfoSlice';
import authReducer from './slices/authSlice';

// Persist configuration
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['categories', 'subcategories', 'contactInfo', 'auth'], // Only persist these slices
};

// Combine all reducers
const rootReducer = combineReducers({
  categories: categoriesReducer,
  subcategories: subcategoriesReducer,
  contactInfo: contactInfoReducer,
  auth: authReducer,
});

// Create persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types for redux-persist
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

// Create persistor
export const persistor = persistStore(store);

// Note: Data initialization is now handled in StoreProvider.jsx
// This ensures data loads after Redux Persist rehydrates

